export default __webpack_public_path__ + "static/media/Dopagut-60-ml-ban.e463ce8c.jpg";